// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manual-add-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.manual-add-container h1 {
  font-size: 28px;
  margin-bottom: 30px;
  color: #333;
  text-align: center;
}

.manual-add-form {
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #444;
  font-size: 14px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4CAF50;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.form-group small {
  display: block;
  margin-top: 5px;
  color: #666;
  font-size: 12px;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover:not(:disabled) {
  background-color: #45a049;
}

.submit-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.error-message {
  padding: 15px;
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  color: #c62828;
  border-radius: 4px;
  margin-top: 20px;
}

.results-container {
  margin-top: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.results-container h2 {
  font-size: 22px;
  margin-bottom: 15px;
  color: #333;
}

.results-summary {
  background-color: #e8f5e9;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.results-summary p {
  margin: 5px 0;
  font-size: 14px;
  color: #2e7d32;
}

.domain-results {
  margin-top: 20px;
}

.domain-results h3 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #444;
}

.domain-result {
  background-color: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 4px;
  border-left: 4px solid #ddd;
}

.domain-result.success {
  border-left-color: #4CAF50;
}

.domain-result.failure {
  border-left-color: #f44336;
  background-color: #ffebee;
}

.domain-result h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 16px;
}

.domain-result p {
  margin: 5px 0;
  font-size: 14px;
  color: #555;
}

.logs {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.logs strong {
  display: block;
  margin-bottom: 8px;
  color: #666;
  font-size: 13px;
}

.logs ul {
  margin: 0;
  padding-left: 20px;
}

.logs li {
  margin: 4px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.error-text {
  color: #c62828;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/component/manualAdd/ManualAddBrand.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".manual-add-container {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 30px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.manual-add-container h1 {\n  font-size: 28px;\n  margin-bottom: 30px;\n  color: #333;\n  text-align: center;\n}\n\n.manual-add-form {\n  margin-bottom: 30px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #444;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #4CAF50;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.form-group small {\n  display: block;\n  margin-top: 5px;\n  color: #666;\n  font-size: 12px;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 14px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background-color: #45a049;\n}\n\n.submit-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.error-message {\n  padding: 15px;\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n  color: #c62828;\n  border-radius: 4px;\n  margin-top: 20px;\n}\n\n.results-container {\n  margin-top: 30px;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n}\n\n.results-container h2 {\n  font-size: 22px;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.results-summary {\n  background-color: #e8f5e9;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.results-summary p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #2e7d32;\n}\n\n.domain-results {\n  margin-top: 20px;\n}\n\n.domain-results h3 {\n  font-size: 18px;\n  margin-bottom: 15px;\n  color: #444;\n}\n\n.domain-result {\n  background-color: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  border-radius: 4px;\n  border-left: 4px solid #ddd;\n}\n\n.domain-result.success {\n  border-left-color: #4CAF50;\n}\n\n.domain-result.failure {\n  border-left-color: #f44336;\n  background-color: #ffebee;\n}\n\n.domain-result h4 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.domain-result p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #555;\n}\n\n.logs {\n  margin-top: 10px;\n  padding: 10px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.logs strong {\n  display: block;\n  margin-bottom: 8px;\n  color: #666;\n  font-size: 13px;\n}\n\n.logs ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.logs li {\n  margin: 4px 0;\n  font-size: 13px;\n  color: #666;\n  line-height: 1.5;\n}\n\n.error-text {\n  color: #c62828;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
